export const encyclopediaEs = {
  // Compartido
  'encyclopedia.lockAria': 'Bloqueado — desbloquea para leer',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'La Enciclopedia',
  'encyclopedia.page.seoDescription':
    'Consulta el grimorio viviente de Grymwyrd — monstruos, hechizos, especies, objetos, localizaciones y más.',
  'encyclopedia.page.heading': 'La Enciclopedia',
  'encyclopedia.page.subtitle': 'El grimorio viviente de todo horror, hechizo y leyenda en Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Buscar {plural}…',
  'encyclopedia.page.searchAria': 'Buscar {plural}',
  'encyclopedia.page.clearSearch': 'Limpiar búsqueda',
  'encyclopedia.page.systemNotLivePrefix': 'El Velo aún no se ha desgarrado para',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Ningún arcano atado a este rito ha traspasado — su grimorio aguarda más allá de la oscuridad.',
  'encyclopedia.page.returnToAllSystems': 'Volver a todos los sistemas',
  'encyclopedia.page.settingNotLivePrefix': 'Las tierras de',
  'encyclopedia.page.settingNotLiveSuffix':
    ' todavía se están cartografiando — sus entradas aún no están vinculadas al escenario. Hasta que los cartógrafos terminen, nada responde aquí.',
  'encyclopedia.page.returnToAllRealms': 'Volver a todos los reinos',
  'encyclopedia.page.filteringBy': 'Filtrando por',
  'encyclopedia.page.filterSystem': 'sistema "{label}"',
  'encyclopedia.page.filterCanon': 'capa canónica "{label}"',
  'encyclopedia.page.filterSetting': 'escenario "{label}"',
  'encyclopedia.page.canonNote': 'La capa canónica se aplica una vez que las entidades se etiquetan en la API (ver _docs/13). ',
  'encyclopedia.page.clear': 'Limpiar',
  'encyclopedia.page.hide': 'Ocultar',
  'encyclopedia.page.filter': 'Filtrar',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Desbloquear {name} (contenido de Grymwyrd)',
  'encyclopedia.entityCard.viewAria': 'Ver entrada de {name}',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Paginación ({position})',
  'encyclopedia.grid.prev': 'Anterior',
  'encyclopedia.grid.next': 'Siguiente',
  'encyclopedia.grid.pageOf': 'Página {page} de {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} resultados',
  'encyclopedia.grid.scrying': 'Escrutando los archivos…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Ordenar descendente',
  'encyclopedia.grid.sortAscAria': 'Ordenar ascendente',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'Modo de vista',
  'encyclopedia.grid.gridViewAria': 'Vista de cuadrícula',
  'encyclopedia.grid.listViewAria': 'Vista de lista',
  'encyclopedia.grid.jumpToLetterAria': 'Saltar a letra',
  'encyclopedia.grid.all': 'Todo',
  'encyclopedia.grid.letterSymbolAria': 'Entradas que comienzan con número o símbolo',
  'encyclopedia.grid.letterAria': 'Entradas que comienzan con {letter}',
  'encyclopedia.grid.emptyTitle': 'El Archivo Permanece en Silencio',
  'encyclopedia.grid.emptyForLetter': 'Ningún {plural} lleva un nombre que comience con "{letter}".',
  'encyclopedia.grid.emptyAll': 'Ningún {plural} responde a tu llamada.',
  'encyclopedia.grid.turningPages': 'Pasando páginas…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (sin obra de arte)',
  'encyclopedia.entityImage.noVision': 'Sin Visión',

  // FacetSidebar
  'encyclopedia.facets.all': 'Todo',
  'encyclopedia.facets.soon': 'Pronto',
  'encyclopedia.facets.navAria': 'Filtros de tipo de entidad',
  'encyclopedia.facets.clearAll': 'Limpiar todos los filtros',
  'encyclopedia.facets.lorebook': 'Libro de Historia',
  'encyclopedia.facets.gameSystem': 'Sistema de Juego',
  'encyclopedia.facets.canonLayer': 'Capa Canónica',
  'encyclopedia.facets.setting': 'Escenario',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Consultar el Velo',
  'encyclopedia.globalSearch.placeholder': 'Buscar monstruos, hechizos, localizaciones, historia…',
  'encyclopedia.globalSearch.queryAria': 'Consulta de búsqueda',
  'encyclopedia.globalSearch.loading': 'Escrutando…',
  'encyclopedia.globalSearch.empty': 'Nada se agita en la oscuridad por "{q}".',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Contenido de Grymwyrd — desbloquea para leer',
  'encyclopedia.lockBadge.label': 'Bloqueado',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Contenido bloqueado',
  'encyclopedia.lockedGate.defaultTitle': 'Esta historia está sellada',
  'encyclopedia.lockedGate.body':
    'El bestiario, hechizos y leyendas de Grymwyrd están vinculados al Cataclismo de Grymwyrd. El canon SRD abierto permanece libre — pero para andar el crepúsculo eterno en sí, reclama el libro.',
  'encyclopedia.lockedGate.unlockCta': 'Desbloquear Grymwyrd',
  'encyclopedia.lockedGate.signInCta': '¿Ya eres mecenas? Inicia sesión',
  'encyclopedia.lockedGate.backerNote':
    'Los mecenas que se comprometieron con Grymwyrd ya poseen esto — inicia sesión para desbloquearlo en tu cuenta.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — se sacó {total}',
  'encyclopedia.table.noRowMatched': 'Ninguna fila coincidió con {total}.',
  'encyclopedia.table.loading': 'Desplegando la tabla…',
  'encyclopedia.table.error': 'Esta tabla no ha podido dibujarse.',
  'encyclopedia.table.roll': 'Tirar {formula}',
  'encyclopedia.table.lastRoll': 'Último tirada: {value}',
  'encyclopedia.table.noMatchingRow': ' · ninguna fila coincidió',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Entrada',
  'encyclopedia.detail.addedToCampaign': 'Añadida a tu campaña.',
  'encyclopedia.detail.addError': 'No se pudo acceder a la bóveda de campaña. Inténtalo más tarde.',
  'encyclopedia.detail.unknownType': 'Tipo de entrada desconocido.',
  'encyclopedia.detail.seoDescription': '{name} — una {label} en la Enciclopedia de Grymwyrd.',
  'encyclopedia.detail.breadcrumbAria': 'Ruta de navegación',
  'encyclopedia.detail.breadcrumbRoot': 'Enciclopedia',
  'encyclopedia.detail.sourceVersionAria': 'Versión de origen',
  'encyclopedia.detail.versionConsolidated': 'Consolidada',
  'encyclopedia.detail.versionBook': 'Libro Específico',
  'encyclopedia.detail.removeBookmarkAria': 'Quitar marcador',
  'encyclopedia.detail.addBookmarkAria': 'Añadir marcador',
  'encyclopedia.detail.bookmarked': 'Marcada',
  'encyclopedia.detail.bookmark': 'Marcador',
  'encyclopedia.detail.addToCampaign': 'Añadir a la Campaña',
  'encyclopedia.detail.sealedTitle': '{name} está sellada',
  'encyclopedia.detail.bookVariantNote':
    'Mostrando el registro consolidado; el texto variante por libro aparecerá aquí una vez que se vinculen las ediciones de libros.',
  'encyclopedia.detail.tablistAria': 'Secciones de entrada',
  'encyclopedia.detail.tab.lore': 'Historia',
  'encyclopedia.detail.tab.stats': 'Características',
  'encyclopedia.detail.tab.gallery': 'Galería',
  'encyclopedia.detail.tab.relations': 'Relaciones',
  'encyclopedia.detail.tab.discussions': 'Discusiones',
  'encyclopedia.detail.tab.claims': 'Reclamaciones de Jugadores',
  'encyclopedia.detail.loading': 'Despertando la entrada…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Desenterrando la historia…',
  'encyclopedia.lore.empty': 'Las historias de esta entrada permanecen aún sin escribir.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Leyendo las runas…',
  'encyclopedia.stats.empty': 'No hay mecánicas registradas para esta entrada.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Revelando las visiones…',
  'encyclopedia.gallery.emptyTitle': 'Aún Sin Visiones',
  'encyclopedia.gallery.emptyBody': 'Ninguna obra de arte ha sido vinculada a esta entrada. Contribuye una en la Bóveda.',
  'encyclopedia.gallery.artworkAlt': 'Obra de arte de entidad',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Reuniendo susurros…',
  'encyclopedia.discussions.emptyTitle': 'Silencio en los Salones',
  'encyclopedia.discussions.emptyBody': 'Sé el primero en discutir esta entrada con otros viajeros.',
  'encyclopedia.discussions.startCta': 'Iniciar una Discusión',
  'encyclopedia.discussions.untitledThread': 'Hilo sin título',
  'encyclopedia.discussions.byAuthor': 'de {author}',
  'encyclopedia.discussions.replyCount': '{count} respuestas',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Tu reclamación ha sido registrada para revisión.',
  'encyclopedia.claims.recordError': 'Los escribas no pudieron registrar tu reclamación. Inténtalo más tarde.',
  'encyclopedia.claims.loading': 'Consultando el canon…',
  'encyclopedia.claims.emptyTitle': 'Aún Sin Reclamaciones de Jugadores',
  'encyclopedia.claims.emptyBody': 'Ningún viajero ha tejido todavía su leyenda en esta entrada.',
  'encyclopedia.claims.claimCta': 'Reclamar esto',
  'encyclopedia.claims.signInCta': 'Inicia sesión para reclamar',
  'encyclopedia.claims.untitledClaim': 'Reclamación sin título',
  'encyclopedia.claims.byAuthor': 'de {author}',
  'encyclopedia.claims.addCta': 'Añade tu reclamación',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Esta Entrada',
  'encyclopedia.relations.relationLabel': 'Relación {index}',
  'encyclopedia.relations.kindredLabel': 'Afín {index}',
  'encyclopedia.relations.loading': 'Trazando los hilos del destino…',
  'encyclopedia.relations.hintIntro': 'Haz clic en un nodo para viajar a esa entrada. Los hilos mostrados son',
  'encyclopedia.relations.hintCanonical': ' relaciones canónicas.',
  'encyclopedia.relations.hintKindred': ' afines del mismo tipo.',
}
